module.exports = require("/app/builder-v2/webapp/gatsby-config/gatsby-browser.ts");